import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { mapToModel } from '@kinet-open-network/client/shared/data-access/model';
import { formatISO } from 'date-fns';
import { CustomerAdditionalProduct } from '../models/customer-additional-product.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerAdditionalProductsService extends BaseApiService<CustomerAdditionalProduct> {
  override model: Type<CustomerAdditionalProduct> = CustomerAdditionalProduct;

  override get endpoint(): string {
    return '/customer-additional-products';
  }

  setActivationDate(id: string, activationDate: Date | null) {
    return this.http
      .put<CustomerAdditionalProduct>(
        `${this.endpoint}/${id}/activation-date`,
        {
          activationDate: activationDate
            ? formatISO(activationDate, { representation: 'date' })
            : null,
        },
      )
      .pipe(mapToModel(this.model));
  }

  setDeactivationDate(id: string, deactivationDate: Date | null) {
    return this.http
      .put<CustomerAdditionalProduct>(
        `${this.endpoint}/${id}/deactivation-date`,
        {
          deactivationDate: deactivationDate
            ? formatISO(deactivationDate, { representation: 'date' })
            : null,
        },
      )
      .pipe(mapToModel(this.model));
  }

  setInvoicingPeriod(
    id: string,
    data: { invoiceFrom: Date | null; invoiceTo: Date | null },
  ) {
    return this.http
      .put<CustomerAdditionalProduct>(`${this.endpoint}/${id}/invoicing/period`, {
        invoiceFrom: data.invoiceFrom
          ? formatISO(data.invoiceFrom, { representation: 'date' })
          : null,
        invoiceTo: data.invoiceTo
          ? formatISO(data.invoiceTo, { representation: 'date' })
          : null,
      })
      .pipe(mapToModel(this.model));
  }

  setInvoiceState(id: string, invoiceDate: Date | null) {
    return this.http
      .put<CustomerAdditionalProduct>(
        `${this.endpoint}/${id}/invoicing/state`,
        {
          invoiceDate: invoiceDate
            ? formatISO(invoiceDate, { representation: 'date' })
            : null,
        },
      )
      .pipe(mapToModel(this.model));
  }
}
